import api from './api';

// ==================== MEMBRES ====================

export const getMembres = async (params = {}) => {
  const response = await api.get('/ara/membres', { params });
  return response.data;
};

export const getMembre = async (id) => {
  const response = await api.get(`/ara/membres/${id}`);
  return response.data;
};

export const createMembre = async (data) => {
  const response = await api.post('/ara/membres', data);
  return response.data;
};

export const updateMembre = async (id, data) => {
  const response = await api.put(`/ara/membres/${id}`, data);
  return response.data;
};

export const deleteMembre = async (id) => {
  const response = await api.delete(`/ara/membres/${id}`);
  return response.data;
};

export const getMembreCotisations = async (id) => {
  const response = await api.get(`/ara/membres/${id}/cotisations`);
  return response.data;
};

export const getMembresStats = async () => {
  const response = await api.get('/ara/membres/stats');
  return response.data;
};

// ==================== COTISATIONS ====================

export const getCotisations = async (params = {}) => {
  const response = await api.get('/ara/cotisations', { params });
  return response.data;
};

export const getCotisation = async (id) => {
  const response = await api.get(`/ara/cotisations/${id}`);
  return response.data;
};

export const createCotisation = async (data) => {
  const response = await api.post('/ara/cotisations', data);
  return response.data;
};

export const updateCotisation = async (id, data) => {
  const response = await api.put(`/ara/cotisations/${id}`, data);
  return response.data;
};

export const deleteCotisation = async (id) => {
  const response = await api.delete(`/ara/cotisations/${id}`);
  return response.data;
};

export const getCotisationsStats = async (year = null) => {
  const response = await api.get('/ara/cotisations/stats', { params: { year } });
  return response.data;
};

export const getCotisationsStatus = async () => {
  const response = await api.get('/ara/cotisations/status');
  return response.data;
};

// ==================== TYPES DE COTISATION ====================

export const getTypesCotisation = async () => {
  const response = await api.get('/ara/types-cotisation');
  return response.data;
};

export const createTypeCotisation = async (data) => {
  const response = await api.post('/ara/types-cotisation', data);
  return response.data;
};

export const updateTypeCotisation = async (id, data) => {
  const response = await api.put(`/ara/types-cotisation/${id}`, data);
  return response.data;
};

export const deleteTypeCotisation = async (id) => {
  const response = await api.delete(`/ara/types-cotisation/${id}`);
  return response.data;
};

// ==================== PRESTATIONS ====================

export const getPrestations = async (params = {}) => {
  const response = await api.get('/ara/prestations', { params });
  return response.data;
};

export const getPrestation = async (id) => {
  const response = await api.get(`/ara/prestations/${id}`);
  return response.data;
};

export const createPrestation = async (data) => {
  const response = await api.post('/ara/prestations', data);
  return response.data;
};

export const updatePrestation = async (id, data) => {
  const response = await api.put(`/ara/prestations/${id}`, data);
  return response.data;
};

export const deletePrestation = async (id) => {
  const response = await api.delete(`/ara/prestations/${id}`);
  return response.data;
};

export const getPrestationsStats = async (year = null) => {
  const response = await api.get('/ara/prestations/stats', { params: { year } });
  return response.data;
};

// ==================== DEPENSES ====================

export const getDepenses = async (params = {}) => {
  const response = await api.get('/ara/depenses', { params });
  return response.data;
};

export const getDepense = async (id) => {
  const response = await api.get(`/ara/depenses/${id}`);
  return response.data;
};

export const createDepense = async (data) => {
  const response = await api.post('/ara/depenses', data);
  return response.data;
};

export const updateDepense = async (id, data) => {
  const response = await api.put(`/ara/depenses/${id}`, data);
  return response.data;
};

export const deleteDepense = async (id) => {
  const response = await api.delete(`/ara/depenses/${id}`);
  return response.data;
};

export const getDepensesStats = async (year = null) => {
  const response = await api.get('/ara/depenses/stats', { params: { year } });
  return response.data;
};
